export function formatLinkedInTime(value?: string): string {
  if (!value) return '';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';

  const diffMs = Date.now() - date.getTime();
  const mins = Math.floor(diffMs / 60000);
  if (mins < 1) return 'now';
  if (mins < 60) return `${mins}m`;

  const hours = Math.floor(mins / 60);
  if (hours < 24) return `${hours}h`;

  const days = Math.floor(hours / 24);
  if (days < 7) return `${days}d`;

  return date.toLocaleDateString([], { month: 'short', day: 'numeric' });
}

export type NotificationFilterKey =
  | 'all'
  | 'messaging'
  | 'community'
  | 'appointment'
  | 'store'
  | 'vault';

export const NOTIFICATION_FILTERS: { key: NotificationFilterKey; label: string; category?: string }[] = [
  { key: 'all', label: 'All' },
  { key: 'messaging', label: 'Messages', category: 'messaging' },
  { key: 'community', label: 'Communities', category: 'community' },
  { key: 'appointment', label: 'Appointments', category: 'appointment' },
  { key: 'store', label: 'Store', category: 'store' },
  { key: 'vault', label: 'Wallet', category: 'vault' },
];
